// @ts-nocheck
import { Card, Fonts, Input } from "@snapchat/snap-design-system";
import { type FC, useCallback } from "react";
import { Visible } from "../../common/components";
import { ActionModal } from "../../common/components/ActionModal";
import {
    modalStyle,
    listContainer,
    headerStyle,
    searchInputStyle,
    SyledSearchIcon,
    SearchInputContainer,
    modalContainerStyle,
} from "../../common/styles";
import { useSelection } from "../../core/hooks";
import { useInputState } from "../../core/validation";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../gql-generated/types";
import { LensSourcesContainer } from "../container/LensSourcesContainer";
import { type SourceModel } from "../models";

interface AddLensSourceModalProps {
    onAdd: (values: SourceModel[]) => Promise<unknown>;
    onCancel: () => void;
    visible: boolean;
    selectedType: LensSourceType;
    enabling: boolean;
}

export const AddLensSourceModal: FC<AddLensSourceModalProps> = ({
    onAdd,
    onCancel,
    visible,
    selectedType,
    enabling,
}) => {
    const { selectedItems, resetSelection, toggleItemSelection } = useSelection<SourceModel>((source) => source.id);

    const addLensSources = useCallback(() => {
        onAdd([...selectedItems.values()])
            .catch(console.info)
            .finally(() => onCancel());
    }, [onAdd, selectedItems, onCancel]);

    const { inputProps: searchInputProps, reset: resetSearch } = useInputState<string>({
        error: "",
        validator: () => true,
        defaultValue: "",
    });

    const handleCancel = useCallback(() => {
        onCancel();
        resetSearch();
    }, [onCancel, resetSearch]);

    return (
        <ActionModal
            className={modalStyle}
            padBody={false}
            actionText={"Add Sources"}
            visible={visible}
            onCancel={handleCancel}
            onAction={addLensSources}
            didClose={resetSelection}
            isActionButtonPending={enabling}
            isActionButtonDisabled={selectedItems.size <= 0 || enabling}
            isCancelButtonDisabled={enabling}
            shouldAddKeyEvent={selectedItems.size > 0}
        >
            <Card
                title={"Add Lens Source"}
                padBody={false}
                titleBorder={false}
                titleStyle={Fonts.Heading.H500}
                className={modalContainerStyle}
            >
                <Card.Section className={headerStyle}>
                    <SearchInputContainer>
                        <Input {...searchInputProps} className={searchInputStyle} placeholder="Search Lens Sources" />
                        <SyledSearchIcon />
                    </SearchInputContainer>
                </Card.Section>
                <Card.Section className={listContainer} padBody={false}>
                    <Visible when={selectedType != null}>
                        <LensSourcesContainer
                            type={selectedType}
                            selectedItems={selectedItems}
                            toggleSelection={toggleItemSelection}
                            searchValue={searchInputProps.value}
                        />
                    </Visible>
                </Card.Section>
            </Card>
        </ActionModal>
    );
};
